module.exports = __webpack_public_path__ + "img/2..c88629db.jpg";